var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DateTimePicker',_vm._g(_vm._b({attrs:{":clearable":false,"first-day-of-week":_vm.firstDay,"format":_vm.format,"lang":_vm.lang,"minute-step":5,"show-second":false,"type":"time","use12h":_vm.showAmPm,"value":_vm.date},on:{"change":_vm.change}},'DateTimePicker',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }